const Footer = () => {
    return (
        <div>
            <h6>
                Project by{' '}
                <a
                    href="https://ianrackson.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Ian Rackson
                </a>
            </h6>
        </div>
    );
};

export default Footer;
